import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=182099fb"
import script from "./SkeletonBox.vue?vue&type=script&lang=js"
export * from "./SkeletonBox.vue?vue&type=script&lang=js"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&id=182099fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports